import React from "react";
import "./Auth.scss";

const AuthLayout = ({ children }: any) => {
  return (
    <div className="authContainer">
      <div className="auth_left">
        <figure className="auth_logo">
          <h2>It's My Wall</h2>
        </figure>
        <div className="auth_welcome">
          <span className="welcome_subtitle">Welcome back!</span>
          <h1 className="welcome_title">
            Log in to continue<br />
            creating stunning wall art.
          </h1>
        </div>
      </div>
      <div className="auth_right">
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
